import { Routes, Route } from "react-router-dom";
import Intro from "../pages/Intro";
import Blog from "../pages/Blog";
import UnresponsiveCol from "../pages/UnresponsiveCol";
import GitNotes from "../pages/GitNotes";
import IntroToDevOps from "../pages/IntroToDevOps";
import Page404 from "../pages/Page404";
import RedirectPage from "../pages/RedirectPage";
import NeverTooLate from "../pages/NeverTooLate";

function Main() {
  return (
    <>
      <div id="main">
        <Routes>
          <Route path="/" element={<Intro />} />
          <Route path="/blog/" element={<Blog />} />
          <Route
            path="/blog/unresponsive-single-column-in-bootstrap/"
            element={<UnresponsiveCol />}
          />
          <Route
            path="/blog/merge-local-and-remote-repos-in-git/"
            element={<GitNotes />}
          />
          <Route path="/blog/intro-to-devops/" element={<IntroToDevOps />} />
          <Route
            path="/blog/redirect-page-in-react/"
            element={<RedirectPage />}
          />
          <Route path="/blog/its-never-too-late/" element={<NeverTooLate />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </div>
    </>
  );
}

export default Main;
